import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, count }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`Rated ${value} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full || (i === full && half);
        return (
          <Star
            key={i}
            size={size}
            className={filled ? "fill-yellow-400 text-yellow-400" : "text-slate-300"}
            strokeWidth={1.5}
          />
        );
      })}
      {count !== undefined && (
        <span className="ml-1 text-[11px] font-mono text-slate-500">({count})</span>
      )}
    </span>
  );
}
